'use strict';

/**
 * Renders order info block for contact us form
 * @param {Object} pdict - data object to generate HTML
 * @returns {string} HTML markup as string
 */
const template = (pdict) => `
        <h2>${pdict.message}</h2>
        <p>
            <strong>Order Number:</strong>
            <span>${pdict.data.orderNumber}</span>
        </p>
        <p>
            <strong>Order Status:</strong>
            <span>${pdict.data.status}</span>
        </p>
        <p>
            <strong>Tracking Information:</strong>
            <span> ${pdict.data.trackingUrl}</span>
        </p>
        <p>
            <strong>Tracking Number:</strong>
            <span> ${pdict.data.trackingNo}</span>
        </p>
        <p class="mt-4">
            <strong>If you still want to contact us, click the button below to submit
            this ticket to our account support team. Thank you!</strong>
        </p>`;

module.exports = template;
